import { render, staticRenderFns } from "./BottomMiniPlayer.vue?vue&type=template&id=2cd89628&scoped=true&"
import script from "./BottomMiniPlayer.vue?vue&type=script&lang=js&"
export * from "./BottomMiniPlayer.vue?vue&type=script&lang=js&"
import style0 from "./BottomMiniPlayer.vue?vue&type=style&index=0&id=2cd89628&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd89628",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VBtn,VIcon,VProgressCircular,VSlider})
